import { Directive, EventEmitter, HostListener, Output } from "@angular/core";

@Directive({
  selector: "[appDragDrop]",
  standalone: false,
})
export class DragDropDirective {
  @Output() onFileDropped = new EventEmitter<FileList>();

  @HostListener("dragover", ["$event"]) onDragOver(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
  }

  @HostListener("dragleave", ["$event"])
  public onDragLeave(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
  }

  @HostListener("drop", ["$event"])
  public ondrop(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    const files = evt.dataTransfer?.files;
    if (files && files.length > 0) {
      this.onFileDropped.emit(files);
    }
  }
}
